import { OriginalIngredientCategory, OriginalIngredientCategoryData } from './index';
import { ReadCollectionGql } from './gql';

type Data = {
  documents: OriginalIngredientCategoryData[];
  nextToken: string;
};

class OriginalIngredientCategoryCollection {

  readonly documents: OriginalIngredientCategory[];
  readonly nextToken: string;

  constructor(data: Data = { documents: [], nextToken: '' }) {
    this.documents = data.documents.map(it => new OriginalIngredientCategory(it));
    this.nextToken = data.nextToken;
  }

  async readAll(): Promise<this> {
    let collection = this;
    while (collection.nextToken) {
      const gql = await new ReadCollectionGql().fetch({ nextToken: collection.nextToken });
      if (!gql.result) throw new Error('invalid result');
      collection = collection.merge(new OriginalIngredientCategoryCollection(gql.result));
    }
    return collection;
  }

  merge(collection: OriginalIngredientCategoryCollection): this {
    const documents = OriginalIngredientCategory.sort([...this.documents, ...collection.documents]);
    const nextToken = collection.nextToken;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, documents, nextToken });
  }

  add(category: OriginalIngredientCategory ): this {
    const documents = OriginalIngredientCategory.sort([...this.documents, category]);
    return Object.assign(Object.create(this.constructor.prototype), { ...this, documents });
  }

  replace(category: OriginalIngredientCategory ): this {
    const documents = OriginalIngredientCategory.sort(this.documents.map(it => it.id === category.id ? category : it));
    return Object.assign(Object.create(this.constructor.prototype), { ...this, documents });
  }

  remove(category: OriginalIngredientCategory ): this {
    const documents = this.documents.filter(it => it.id !== category.id);
    return Object.assign(Object.create(this.constructor.prototype), { ...this, documents });
  }

  toJSON(): Data {
    const { nextToken } = this;
    const documents = this.documents.map(it => it.toJSON());
    return { documents, nextToken };
  }

  static async read(): Promise<OriginalIngredientCategoryCollection> {
    const gql = await new ReadCollectionGql().fetch();
    if (!gql.result) throw new Error('invalid result');
    return new OriginalIngredientCategoryCollection(gql.result);
  }

}

export { OriginalIngredientCategoryCollection };
export type { Data as OriginalIngredientCategoryCollectionData };